import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { PaidFeatureUpsellComponent } from './paid.feature.upsell.component';

@NgModule({
    declarations: [PaidFeatureUpsellComponent],
    imports: [BrowserModule, RouterModule],
    exports: [PaidFeatureUpsellComponent]
})
export class PaidFeatureUpsellModule { }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/paid.feature.upsell/paid.feature.upsell.module.ts